var map = {
	"./26/StakingRewards.json": 21365,
	"./28/StakingRewards.json": 24455,
	"./29/StakingRewards.json": 75926,
	"./30/StakingRewards.json": 24100,
	"./31/StakingRewards.json": 36869,
	"./32/StakingRewards.json": 68410,
	"./33/StakingRewards.json": 90555,
	"./34/StakingRewards.json": 13048,
	"./35/StakingRewards.json": 77161
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83528;